module.exports = {
  // eslint-disable-next-line
  getCountryDisplayName(lang, country) {
    // This is here because Node 10-12 doesn't support
    // Intl.DisplayNames but all the modern browsers have
    // the support added.
    let countryName = (country && 'r1' === country.toLowerCase()) ? 'gb' : country;
    let name;
    if (Intl.DisplayNames) {
      name = new Intl.DisplayNames([lang], { type: 'region' }).of(
        countryName.toUpperCase()
      );
    }
    return name;
  },
};
